function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
var ConstruxHeader = function ConstruxHeader(_ref) {
  var route = _ref.route;
  var navigate = useNavigate();
  var cmsNavigation = useSelector(function (s) {
    return s.cms.navigation || {};
  });
  var _useParams = useParams(),
    app = _useParams.app,
    itemID = _useParams.itemID;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    navArr = _useState2[0],
    setNavArr = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selected = _useState4[0],
    setSelected = _useState4[1];
  useEffect(function () {
    setNavArr(Object.values(cmsNavigation).filter(function (x) {
      return x.clientApp === app && x.navbar === 'header' && x.archived !== true;
    }));
    setSelected(null);
  }, [app, cmsNavigation]);
  useEffect(function () {
    var tmpItem = Object.values(cmsNavigation).find(function (x) {
      return x._id === itemID;
    });
    if (tmpItem !== null && tmpItem !== void 0 && tmpItem.parentID) setSelected(Object.values(cmsNavigation).find(function (x) {
      return x._id === tmpItem.parentID;
    }));else setSelected(null);
  }, [itemID]);
  if (app !== 'construx') return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ppc-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ppc-header__hr"
  }), /*#__PURE__*/React.createElement("div", {
    className: "construx-header__logo"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/header/construx-logo@2x.png",
    alt: "Construx"
  })), /*#__PURE__*/React.createElement("div", {
    className: "construx-header__content"
  }, /*#__PURE__*/React.createElement("section", null), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("ul", null, navArr.filter(function (x) {
    return !x.parentID;
  }).sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement("li", {
      key: "main-nav-".concat(x._id),
      onClick: function onClick() {
        setSelected(x);
        navigate("/".concat(app, "/").concat(route, "/").concat(x._id));
      }
    }, /*#__PURE__*/React.createElement("span", null, x.title));
  }))))), selected && selected.children && /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ppark-header-dd"
  }, navArr.filter(function (x) {
    return x.parentID === selected._id;
  }).sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      className: "ppark-header-dd__item",
      key: "main-nav-".concat(x._id),
      onClick: function onClick() {
        setSelected(x);
        navigate("/".concat(app, "/").concat(route, "/").concat(x._id));
      }
    }, /*#__PURE__*/React.createElement("span", null, x.title));
  }))));
};
export default ConstruxHeader;